<gbc-page-error-handler [content]="content" [pageError$]="pageError$">
</gbc-page-error-handler>
<ng-template #content>
  @if (healthCheckMetadata$ | async; as metadata) {
    @if (pageInfo$ | async; as pageInfo) {
      <gbc-page-header [pageInfo]="pageInfo"></gbc-page-header>
    }
    <gbc-page-container>
      <gbc-tile [title]="'energy-management-dashboard.health-check' | translate">
        <app-key-value>
          <dt app-key>{{'energy-management-dashboard.metadata.name' | translate}}</dt>
          <dd app-value>{{metadata.healthCheckName}}</dd>
          <dt app-key>{{'energy-management-dashboard.metadata.message' | translate}}</dt>
          <dd app-value>{{metadata.message}}</dd>
          <dt app-key>{{'energy-management-dashboard.metadata.description' | translate}}</dt>
          <dd app-value>{{metadata.decription}}</dd>
          @if (!!metadata.possibleRootCauses && metadata.possibleRootCauses.length > 0) {
            <dt app-key>{{'energy-management-dashboard.metadata.possible-root-causes' | translate}}</dt>
            <dd app-value>
              <ol>
                @for (possibleRootCause of metadata.possibleRootCauses; track possibleRootCause) {
                  <li>{{possibleRootCause}}</li>
                }
              </ol>
            </dd>
          }
          @if (!!metadata.remedySteps && metadata.remedySteps.length > 0) {
            <dt app-key>{{'energy-management-dashboard.metadata.remedy-suggestions' | translate}}</dt>
            <dd app-value>
              <ol>
                @for (remedyStep of metadata.remedySteps; track remedyStep) {
                  <li>{{remedyStep}}</li>
                }
              </ol>
            </dd>
          }
        </app-key-value>
      </gbc-tile>
    </gbc-page-container>
  }
</ng-template>
